var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76855 1.6875H7.63718C7.86773 1.6875 8.05637 1.94062 8.05637 2.25V4.5H9.31393V2.25C9.31393 1.00898 8.56201 0 7.63718 0H1.76855C0.843715 0 0.0917969 1.00898 0.0917969 2.25V10.125C0.0917969 11.366 0.843715 12.375 1.76855 12.375H3.4453V10.6875H1.76855C1.538 10.6875 1.34936 10.4344 1.34936 10.125V2.25C1.34936 1.94062 1.538 1.6875 1.76855 1.6875ZM5.96043 7.3125H11.8291C12.0596 7.3125 12.2482 7.56563 12.2482 7.875V15.75C12.2482 16.0594 12.0596 16.3125 11.8291 16.3125H5.96043C5.72987 16.3125 5.54124 16.0594 5.54124 15.75V7.875C5.54124 7.56563 5.72987 7.3125 5.96043 7.3125ZM4.28368 7.875V15.75C4.28368 16.991 5.03559 18 5.96043 18H11.8291C12.7539 18 13.5058 16.991 13.5058 15.75V7.875C13.5058 6.63398 12.7539 5.625 11.8291 5.625H5.96043C5.03559 5.625 4.28368 6.63398 4.28368 7.875Z",
    fill: "#1374D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/clone-icon.a78fe92362fdb8eec45f6b1e50d2a4aa.svg";
export { ForwardRef as ReactComponent };